export const getHasFilters = (filters) =>
    Object.values(filters).some((category) => category?.values?.length > 0);

export const getShowBadge = ({ field, filters }) => {
    switch (field) {
        case 'application.risk':
            return filters.riskFilter?.values?.length;
        case 'business_owner':
            return (
                filters.managed3rdParty?.values?.length ||
                filters.managedByPartner?.values?.length ||
                filters.noBusinessOwnerRequired?.values?.length
            );
        case 'ssoType':
            if (filters[field]?.values?.length > 0) {
                return filters[field].values.length - 1; // Section title is counted here, and will always be in the values array
            }
            return false;
        default:
            return filters[field]?.values?.length;
    }
};
